export var lineHeights = {
  desktop: {
    xl: "5.2rem",
    lg: "4.4rem",
    md: "3.6rem",
    sm: "3rem",
    xs: "2.6rem",
    heading: "2.2rem",
    subheading: "1.6rem",
    body: "2rem",
    small: "1.6rem",
    code: "2rem"
  },
  mobile: {
    xl: "3.5rem",
    lg: "2.9rem",
    md: "2.4rem",
    sm: "2rem",
    xs: "1.8rem",
    heading: "2.4rem",
    subheading: "1.7rem",
    body: "2rem",
    small: "1.7rem",
    code: "2rem"
  }
};